import { render, staticRenderFns } from "./SmartVoice.vue?vue&type=template&id=c0373802&scoped=true"
import script from "./SmartVoice.vue?vue&type=script&lang=js"
export * from "./SmartVoice.vue?vue&type=script&lang=js"
import style0 from "./SmartVoice.vue?vue&type=style&index=0&id=c0373802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0373802",
  null
  
)

export default component.exports